import {
  FulfilledLoyaltyEventQualifiedEventsFormValues,
  MadePurchaseQualifiedEventsFormValues,
  TimePeriod,
} from '../../types';

export const hasFilledValuesInPurchaseForm = (
  formValues: MadePurchaseQualifiedEventsFormValues,
) => {
  return (
    formValues.times ||
    formValues.timePeriodType === TimePeriod.FixedWindow ||
    formValues.timePeriodType === TimePeriod.RollingWindow ||
    formValues.fixedWindow?.startDate ||
    formValues.productGroups.length ||
    formValues.threshold ||
    formValues.locations?.length ||
    formValues.locationGroups?.length
  );
};

export const hasFilledValuesInLoyaltyEventForm = (
  formValues: FulfilledLoyaltyEventQualifiedEventsFormValues,
) => {
  return (
    formValues.loyaltyEvent ||
    formValues.times ||
    formValues.timePeriodType === TimePeriod.FixedWindow ||
    formValues.timePeriodType === TimePeriod.RollingWindow
  );
};
